<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-button
              outline
              color="success"
              @click="translateUnfilledFields"
            >一件翻译绿色Field</va-button>
          </div>
          <div class='flex md4 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class='flex md4 sm6 xs12'>
            <va-input
              v-model='insertData.courseId'
              v-show="showUid"
              label='唯一标识'
              disabled
            />
          </div>
          <div class='flex md4 sm6 xs12'>
            <va-input
              v-model='insertData.views'
              v-show="showViews"
              label='views'
              disabled
            />
          </div>

          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.name"
              label="主题"
              :placeholder="placeholders.name"
              removable
              :messages="message"
              :error="!!error.nameErrors.length"
              :error-messages="error.nameErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.nameEn"
              label="主题(英文)"
              :placeholder="placeholders.nameEn"
              removable
              :messages="message"
              :error="!!error.nameEnErrors.length"
              :error-messages="error.nameEnErrors"
              success
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              type="textarea"
              v-model="insertData.lectureTime"
              label="活动时间"
              :autosize="true"
              :placeholder="placeholders.lectureTime"
              :messages="message"
              :error="!!error.lectureTimeErrors.length"
              :error-messages="error.lectureTimeErrors"
              removable
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              type="textarea"
              v-model="insertData.lectureTimeEn"
              label="活动时间(英文)"
              :autosize="true"
              :placeholder="placeholders.lectureTimeEn"
              :messages="message"
              :error="!!error.lectureTimeEnErrors.length"
              :error-messages="error.lectureTimeEnErrors"
              removable
              success
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              type="textarea"
              v-model="insertData.description"
              :placeholder="placeholders.description"
              label="活动介绍"
              :autosize="true"
              :messages="message"
              :error="!!error.descriptionErrors.length"
              :error-messages="error.descriptionErrors"
              removable
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              type="textarea"
              v-model="insertData.descriptionEn"
              :placeholder="placeholders.descriptionEn"
              label="活动介绍(英文)"
              :autosize="true"
              :messages="message"
              :error="!!error.descriptionEnErrors.length"
              :error-messages="error.descriptionEnErrors"
              removable
              success
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-select
              label="讲座/分享会标签"
              v-model="insertData.courseTagIds"
              multiple
              :options="computedTags"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-select
              label="选择加入的群组"
              v-model="insertData.groupId"
              :options="computeGroups"
              :onchange="handleGroupChange"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-select
              label="选择加入的频道"
              v-model="insertData.channelId"
              :options="computeChannels"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-select
              label="导师"
              v-model="insertData.mentorUids"
              multiple
              searchable
              :options="computedMentors"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-select
              label="嘉宾"
              v-model="insertData.honoredGuestUids"
              multiple
              :options="computedHonoredGuests"
            />
          </div>
          <div class='flex md12 sm6 xs12' v-show="insertData.imgUrl.length!==0">
            <va-card
              overlay
              :image='insertData.imgUrl'
              class="va-card-image"
            >
            </va-card>
          </div>
          <div class='flex md12 sm6 xs12'>
            <va-card title='配图'>
              <va-file-upload
                type='single'
                v-model='insertData.imgUrlArr'
                @input="uploadImage"
              />
            </va-card>
          </div>
          <div class="flex md4 sm6 xs12">
            <va-select
              label="状态"
              v-model="insertData.status"
              :options="statusOptions"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.sortNum"
              label="排序"
              placeholder="数字越大越靠前"
              removable
              type="number"
              :min="1"
              oninput="if(value<1)value=1"
              :messages="message"
              :error="!!error.sortNumErrors.length"
              :error-messages="error.sortNumErrors"
            />
          </div>
          <div class="flex md4 sm6 xs12" v-show="insertData.createTime">
            <va-input
              v-model="insertData.createTime"
              label="创建时间"
              disabled
            />
          </div>
        </div>
        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import uploadApi from '../../../api/upload'
import lectureApi from '../../../api/lecture'
import { copyObject, formatTime, translateData } from '../../../utils/common'
import mentorApi from '../../../api/mentor'
import userApi from '../../../api/user'
import groupApi from '../../../api/group'
import tagApi from '../../../api/tag'
import { TAG_TYPE } from '../../../utils/constants'

export default {
  data () {
    return {
      insertData: {
        id: null,
        courseId: '',
        name: '',
        nameEn: '',
        imgUrl: '',
        imgUrlArr: [],
        views: null,
        lectureTime: '',
        lectureTimeEn: '',
        description: '',
        descriptionEn: '',
        status: '草稿中',
        sortNum: 1,
        courseTagIds: [],
        mentorUids: [],
        honoredGuestUids: [],
        createTime: null,
        groupId: '',
        channelId: '',
      },
      placeholders: {
        name: '例: Google面试官数据科学模拟面试',
        nameEn: 'Example: Google interviewer data science mock interview',
        lectureTime: '例: 北京时间 6月10日10:00\n美西时间 6月9日19:00',
        lectureTimeEn: 'Example: 10:00 on June 10, Beijing time\nJune 9, 19:00 EST',
        description: '例: 由Google数据科学家Kevin导师，来做数据科学模拟面试有求职DS相关方向的同学可以扫码报名，欢迎加入活动来旁观学习哟',
        descriptionEn: '例: Example: Instructor Kevin, a Google data scientist, will conduct a data science mock interview. Students who are interested in job hunting and DS-related fields can scan the QR code to sign up. Welcome to join the event to watch and learn.',
      },
      message: ['Required field'],
      courseTags: [],
      mentors: [],
      honoredGuests: [],
      groups: [],
      channels: [],
      error: {
        nameErrors: [],
        nameEnErrors: [],
        sortNumErrors: [],
        lectureTimeErrors: [],
        lectureTimeEnErrors: [],
        descriptionErrors: [],
        descriptionEnErrors: [],
      },
      showId: false,
      showUid: false,
      showViews: false,
      title: '新增讲座/分享会',
      statusOptions: ['草稿中', '已发布', '已下架'],
      submitButtonStatus: true,
    }
  },
  created () {
    const params = this.$route.params
    if (params.id != null) {
      this.showId = true
      this.showUid = true
      this.showViews = true
      this.title = '编辑讲座/分享会'
      // 通过id获取详情
      lectureApi.getLecture(params.id).then(response => {
        copyObject(response.lecture, this.insertData)
        this.insertData.createTime = formatTime(this.insertData.createTime)
        // eslint-disable-next-line no-prototype-builtins
        if (response.lecture.hasOwnProperty('status')) {
          if (response.lecture.status === 0) {
            this.insertData.status = '草稿中'
          } else if (response.lecture.status === 1) {
            this.insertData.status = '已发布'
          } else {
            this.insertData.status = '已下架'
          }
        }
        // eslint-disable-next-line no-prototype-builtins
        if (response.hasOwnProperty('courseTags') && response.courseTags.length !== 0) {
          const that = this
          that.insertData.courseTagIds = []
          response.courseTags.forEach(x => {
            that.insertData.courseTagIds.push(x.name)
          })
        }
        // eslint-disable-next-line no-prototype-builtins
        if (response.hasOwnProperty('mentors') && response.mentors.length !== 0) {
          const that = this
          that.insertData.mentorUids = []
          response.mentors.forEach(x => {
            that.insertData.mentorUids.push(x.nickname + '(' + x.uid + ')')
          })
        }
        // eslint-disable-next-line no-prototype-builtins
        if (response.hasOwnProperty('honoredGuests') && response.honoredGuests.length !== 0) {
          const that = this
          that.insertData.honoredGuestUids = []
          response.honoredGuests.forEach(x => {
            that.insertData.honoredGuestUids.push(x.nickname + '(' + x.uid + ')')
          })
        }
        // eslint-disable-next-line no-prototype-builtins
        if (response.hasOwnProperty('group') && response.group.length !== 0) {
          const that = this
          that.insertData.groupId = response.group.name + '(' + response.group.groupId + ')'
        }
        // eslint-disable-next-line no-prototype-builtins
        if (response.hasOwnProperty('channel') && response.channel.length !== 0) {
          const that = this
          that.insertData.channelId = response.channel.name + '(' + response.channel.channelId + ')'
        }
        // eslint-disable-next-line no-prototype-builtins
        if (response.hasOwnProperty('honoredGuests') && response.honoredGuests.length !== 0) {
          const that = this
          that.insertData.honoredGuestUids = []
          response.honoredGuests.forEach(x => {
            that.insertData.honoredGuestUids.push(x.nickname + '(' + x.uid + ')')
          })
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    }
    this.listGroup()
    this.listChannel()
    this.listCourseTag()
    this.listMentor()
    this.listHonoredGuest()
  },
  computed: {
    formReady () {
      return !this.error.nameErrors.length &&
          !this.error.nameEnErrors.length &&
          !this.error.sortNumErrors.length &&
          !this.error.lectureTimeErrors.length &&
          !this.error.lectureTimeEnErrors.length &&
          !this.error.descriptionErrors.length &&
          !this.error.descriptionEnErrors.length
    },
    handleGroupChange () {
      this.clearChannel()
      this.listChannel()
    },
    computedTags () {
      return this.courseTags.map(x => {
        return x.name
      })
    },
    computedMentors () {
      return this.mentors.map(x => {
        return x.nickname + '(' + x.uid + ')'
      })
    },
    computeGroups () {
      return this.groups.map(x => {
        return x.name + '(' + x.groupId + ')'
      })
    },
    computeChannels () {
      return this.channels.map(x => {
        return x.name + '(' + x.channelId + ')'
      })
    },
    computedHonoredGuests () {
      return this.honoredGuests.map(x => {
        return x.nickname + '(' + x.uid + ')'
      })
    },
    flipTags () {
      const flipTags = {}
      this.courseTags.forEach(x => {
        flipTags[x.name] = x.id
      })
      return flipTags
    },
    flipMentors () {
      const flipMentors = {}
      this.mentors.forEach(x => {
        flipMentors[x.nickname + '(' + x.uid + ')'] = x.uid
      })
      return flipMentors
    },
    flipHonoredGuests () {
      const flipHonoredGuests = {}
      this.honoredGuests.forEach(x => {
        flipHonoredGuests[x.nickname + '(' + x.uid + ')'] = x.uid
      })
      return flipHonoredGuests
    },
    flipGroups () {
      const flipGroups = {}
      this.groups.forEach(x => {
        flipGroups[x.name + '(' + x.groupId + ')'] = x.groupId
      })
      return flipGroups
    },
    flipChannels () {
      const flipChannels = {}
      this.channels.forEach(x => {
        flipChannels[x.name + '(' + x.channelId + ')'] = x.channelId
      })
      return flipChannels
    },
  },
  methods: {
    listMentor () {
      const params = {
        pageNumber: 1,
        pageSize: 1000,
      }
      mentorApi.listMentor(params).then(response => {
        this.mentors = response.mentors
      }).catch(error => {
        console.log(error)
      })
    },
    listHonoredGuest () {
      const params = {
        pageNumber: 1,
        pageSize: 1000,
        userType: 3,
      }
      userApi.listUser(params).then(response => {
        this.honoredGuests = response.users
      }).catch(error => {
        console.log(error)
      })
    },
    listGroup () {
      groupApi.listGroup().then(response => {
        this.groups = response.groups
        this.listChannel()
        this.loading = false
      }).catch(error => alert(error))
    },
    listChannel () {
      console.log(this.insertData.groupId)
      if (!this.insertData.groupId) return
      this.loading = true
      groupApi.listChannel(this.flipGroups[this.insertData.groupId])
        .then(response => {
          this.channels = response.channels
          this.loading = false
        }).catch(error => alert(error))
    },
    listCourseTag () {
      tagApi.listTag({ tagType: TAG_TYPE.COURSE_TAG.CODE }).then(response => {
        this.courseTags = response.tags
      }).catch(error => {
        console.log(error)
      })
    },
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      if (this.insertData.imgUrl.length === 0) {
        this.showToast('有图片未上传，请请检查后重试！', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }
      this.changeButtonStatus(false)
      const data = {
        name: this.insertData.name,
        nameEn: this.insertData.nameEn,
        courseId: this.insertData.courseId,
        views: this.insertData.views,
        imgUrl: this.insertData.imgUrl,
        lectureTime: this.insertData.lectureTime,
        lectureTimeEn: this.insertData.lectureTimeEn,
        description: this.insertData.description,
        descriptionEn: this.insertData.descriptionEn,
        sortNum: this.insertData.sortNum !== null ? this.insertData.sortNum : 1,
        courseTagIds: this.insertData.courseTagIds.map(tagName => {
          return this.flipTags[tagName]
        }),
        mentorUids: this.insertData.mentorUids.map(nicknameWithUid => {
          return this.flipMentors[nicknameWithUid]
        }),
        honoredGuestUids: this.insertData.honoredGuestUids.map(nicknameWithUid => {
          return this.flipHonoredGuests[nicknameWithUid]
        }),
        groupId: this.flipGroups[this.insertData.groupId],
        channelId: this.flipChannels[this.insertData.channelId],
      }
      if (this.insertData.status === null || this.insertData.status === '草稿中') {
        data.status = 0
      } else if (this.insertData.status === '已发布') {
        data.status = 1
      } else {
        data.status = 2
      }

      if (this.insertData.id != null) {
        data.id = this.insertData.id
        lectureApi.updateLecture(data.id, data).then(response => {
          if (response.success === true) {
            this.showToast('更新分享会/讲座成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listLecture' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      } else {
        lectureApi.saveLecture(data).then(response => {
          if (response.success === true) {
            this.showToast('保存分享会/讲座成功', {
              duration: 1000,
              icon: 'fa-warning',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listLecture' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickCancel () {
    },
    checkField () {
      this.error.nameErrors = this.insertData.name ? [] : ['name is required']
      this.error.nameEnErrors = this.insertData.nameEn ? [] : ['nameEn is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
      this.error.lectureTimeErrors = this.insertData.lectureTime ? [] : ['lectureTime is required']
      this.error.lectureTimeEnErrors = this.insertData.lectureTimeEn ? [] : ['lectureTimeEn is required']
      this.error.descriptionErrors = this.insertData.description ? [] : ['description is required']
      this.error.descriptionEnErrors = this.insertData.descriptionEn ? [] : ['descriptionEn is required']
    },
    uploadImage () {
      if (this.insertData.imgUrlArr.length === 0) return
      const formData = new FormData()
      formData.append('type', 'image')
      formData.append('file', this.insertData.imgUrlArr[this.insertData.imgUrlArr.length - 1])
      uploadApi.uploadImage(formData).then(response => {
        this.insertData.imgUrl = response.url
        this.showToast('上传图片成功', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
    clearChannel () {
      this.channels.forEach(x => {
        if (x.groupId !== this.flipGroups[this.insertData.groupId]) {
          this.insertData.channelId = ''
        }
      })
    },
    async translateUnfilledFields () {
      // 课程标题
      if (this.insertData.name !== '' && this.insertData.nameEn === '') {
        this.insertData.nameEn = await translateData(this.insertData.name)
      }
      // 课程介绍
      if (this.insertData.description !== '' && this.insertData.descriptionEn === '') {
        this.insertData.descriptionEn = await translateData(this.insertData.description)
      }
      // 活动时间
      if (this.insertData.lectureTime !== '' && this.insertData.lectureTimeEn === '') {
        this.insertData.lectureTimeEn = await translateData(this.insertData.lectureTime)
      }
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
